import { Component, input, TemplateRef, ChangeDetectionStrategy } from '@angular/core';

import { DataUri, dataUriToBlob, isDataUri } from '@softline/core';
import { SignaturePadComponent } from '../../signature-pad/signature-pad.component';
import { TranslatePipe } from '@softline/ui-core';
import { ResolvableModal } from '@softline/ui-core';

@Component({
  selector: 'soft-signature-modal',
  imports: [SignaturePadComponent, TranslatePipe],
  templateUrl: './signature-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './signature-modal.component.css',
})
export class SignatureModalComponent extends ResolvableModal<Blob | null>{
  showCancel = input<boolean>(false);

  onSubmit(value: DataUri | null): void {
    if (isDataUri(value)) {
      const blob = dataUriToBlob(value);
      this.resolve(blob);
    } else
      this.resolve(value);
  }
}
